export default () => ({
    loading:false,
    list:[],
    emptyBox:[]
})